// NOTE: Enums
export enum TixRegionTypes {
	AT = 'AT',
	BE = 'BE',
	CZ = 'CZ',
	DE = 'DE',
	DK = 'DK',
	ES = 'ES',
	FI = 'FI',
	FR = 'FR',
	IE = 'IE',
	IT = 'IT',
	NL = 'NL',
	NO = 'NO',
	NON_EU = 'NON-EU',
	PL = 'PL',
	PT = 'PT',
	RO = 'RO',
	SE = 'SE',
	GR = 'GR',
}

export enum TixPrimaryTypes {
	ACCOR_ARENA = 'accor-arena',
	ALL_ACCESS = 'all-access',
	AXS_SE = 'axs-se',
	AXS_UK = 'axs-uk',
	AXS_US = 'axs-us',
	AXS_DE = 'axs-de',
	BANQUET = 'banquet',
	BLUETICKET = 'blueticket',
	DICE = 'dice',
	ETICKETING = 'eticketing',
	EVENTIM_DE = 'eventim-de',
	EVENTIM_NL = 'eventim-nl',
	EVENTIM_NO = 'eventim-no',
	EVENTIM_UK = 'eventim-uk',
	FIFA = 'fifa',
	FNAC = 'fnac',
	GIGS_AND_TOURS = 'gigs-tours',
	IABILET = 'iabilet',
	INTER = 'inter',
	KOKO = 'koko',
	LDN_COLI = 'ldn-coli',
	LIPPU_FI = 'lippu-fi',
	LW_THEATRES = 'lw-theatres',
	MISC = 'misc',
	OETICKET = 'oeticket',
	PARADISO = 'paradiso',
	PAYLOGIC = 'paylogic',
	PDC = 'pdc',
	PHIL_ORKEST = 'phil-orkest',
	RESIDENT_ADVISOR = 'resident-advisor',
	ROLAND_GARROS = 'roland-garros',
	ROUNDHOUSE = 'roundhouse',
	ROYAL_ALBERT_HALL = 'royal-albert-hall',
	SEATGEEK = 'seatgeek',
	SEETICKETS = 'seetickets',
	SKIDDLE = 'skiddle',
	SUPERBOLETOS = 'superboletos',
	TICKETCORNER_CH = 'ticketcorner-ch',
	TICKETEK = 'ticketek',
	TICKETERA = 'ticketera',
	TICKETONE = 'ticketone',
	TICKETPOINT = 'ticketpoint',
	TICKETSWAP = 'ticketswap',
	TIXEL = 'tixel',
	TIXSTOCK = 'tixstock',
	TM_AT = 'tm-at',
	TM_BE = 'tm-be',
	TM_CH = 'tm-ch',
	TM_CZ = 'tm-cz',
	TM_DE = 'tm-de',
	TM_DK = 'tm-dk',
	TM_ES = 'tm-es',
	TM_FR = 'tm-fr',
	TM_GR = 'tm-gr',
	TM_IE = 'tm-ie',
	TM_IT = 'tm-it',
	TM_MX = 'tm-mx',
	TM_NL = 'tm-nl',
	TM_NO = 'tm-no',
	TM_PL = 'tm-pl',
	TM_SE = 'tm-se',
	TM_UAE = 'tm-uae',
	TM_UK = 'tm-uk',
	TM_US = 'tm-us',
	UEFA = 'uefa',
	VIAGOGO = 'viagogo',
	VOLTAIRE = 'voltaire',
	WIMBLEDON = 'wimbledon',
	SKATECAFE = 'skatecafe',
	BRISTOL_BEACON = 'bristol-beacon',
	PRTICKET = 'prticket',
	GO_TO_BEAT = 'gotobeat',
	TIVOLI_VREDENBURG = 'tivolivredenburg',
}

export enum TixSecondaryTypes {
	DTI = 'dti',
	FIFA_RESALE = 'fifa-resale',
	GIGSBERG = 'gigsberg',
	INVOICE = 'invoice',
	LYSTED = 'lysted',
	MARKTPLAATS = 'marktplaats',
	NA = 'n/a',
	PAYPAL_PRIVE = 'paypal',
	PASSETONBILLET = 'passetonbillet',
	REFUND = 'refund',
	SKYBOX = 'skybox',
	STUBHUB_INT = 'stubhub-int',
	STUBHUB_UK = 'stubhub-uk',
	TM_RESALE = 'tm-resale',
	TICKETSWAP = 'ticketswap',
	TICOMBO = 'ticombo',
	TIXSTOCK = 'tixstock',
	TWICKETS = 'twickets',
	UNSOLD = 'unsold',
	VIAGOGO = 'viagogo',
	WELIST = 'welist',
}

export const TixSecondaryName: Record<TixSecondaryTypes, string> = {
	[TixSecondaryTypes.DTI]: 'DTI',
	[TixSecondaryTypes.FIFA_RESALE]: 'Fifa Resale',
	[TixSecondaryTypes.GIGSBERG]: 'Gigsberg',
	[TixSecondaryTypes.INVOICE]: 'Invoice',
	[TixSecondaryTypes.LYSTED]: 'Lysted',
	[TixSecondaryTypes.MARKTPLAATS]: 'Marktplaats',
	[TixSecondaryTypes.NA]: 'N/A',
	[TixSecondaryTypes.PAYPAL_PRIVE]: 'Paypal',
	[TixSecondaryTypes.PASSETONBILLET]: 'PasseTonBillet',
	[TixSecondaryTypes.REFUND]: 'Refund',
	[TixSecondaryTypes.SKYBOX]: 'Sybox',
	[TixSecondaryTypes.STUBHUB_INT]: 'StubHub Int.',
	[TixSecondaryTypes.STUBHUB_UK]: 'StubHub UK',
	[TixSecondaryTypes.TM_RESALE]: 'TM Resale',
	[TixSecondaryTypes.TICKETSWAP]: 'Ticketswap',
	[TixSecondaryTypes.TICOMBO]: 'Ticombo',
	[TixSecondaryTypes.TIXSTOCK]: 'Tixstock',
	[TixSecondaryTypes.TWICKETS]: 'Twickets',
	[TixSecondaryTypes.UNSOLD]: 'Unsold',
	[TixSecondaryTypes.VIAGOGO]: 'Viagogo',
	[TixSecondaryTypes.WELIST]: 'Welist',
};

export enum TixTransferTypes {
	FINE = 'fine',
	TRANSFER = 'transfer',
	E_TICKET = 'e-ticket',
	SMP = 'smp',
	BARCODE = 'barcode',
	PAPER = 'paper',
	PRE_UPLOAD = 'pre-upload',
	BOX_OFFICE = 'box-office',
	REFUND = 'refund',
	RESALE = 'resale',
}

export enum TixTransferNames {
	FINE = 'Fine',
	TRANSFER = 'Transfer',
	E_TICKET = 'E-Ticket',
	SMP = 'SMP',
	BARCODE = 'Barcode',
	PAPER = 'Paper',
	PRE_UPLOAD = 'Preupload',
	BOX_OFFICE = 'Box Office',
	REFUND = 'Refund',
	RESALE = 'Resale',
}

export enum TixCompletedStatusTypes {
	COMPLETED = 'completed',
	ACTION_NEEDED = 'action-needed',
	BUYER_PENDING = 'buyer-pending',
}

export enum TixCurrencyTypes {
	GBP = 'GBP',
	USD = 'USD',
	PLN = 'PLN',
	CAD = 'CAD',
	MXN = 'MXN',
	RON = 'RON',
	HUF = 'HUF',
	AUD = 'AUD',
	SGD = 'SGD',
	CZK = 'CZK',
	CHF = 'CHF'
}

export enum TixBankTypes {
	WALLESTER_USD = 'wallester-usd',
	WALLESTER_GBP = 'wallester-gbp',
	WALLESTER = 'wallester',
	REVOLUT = 'revolut',
	KNAB = 'knab',
	GIFTCARD = 'giftcard',
	PAYPAL = 'paypal',
	UNKNOWN = 'unknown',
	PRIVATE = 'private',
	VIVID = 'vivid',
	AMEX = 'amex',
}

// NOTE: Types
export type TixEvent = {
	id: string;
	event: string;
	date: string;
	city: string;
	region: TixRegionTypes;
};

export type TixOrder = {
	id: string;
	email: string;
	eventId: TixEvent['id'];
	reference: string;
	primary: TixPrimaryTypes;
	quantity: number;
	paymentTotal: number | null;
	paymentNative: number | null;
	paymentNativeCurrency: TixCurrencyTypes | null;
	paymentSplits: {
		payment: number | null;
		bank: TixBankTypes;
	}[];
	paymentDate: string;
	hash: string;
};

export type TixBought = {
	id: string;
	orderId: TixOrder['id'];
	section: string;
	row: string;
	seat: string;
	price: number | null;
	noteAisle: boolean;
	noteSide: boolean;
	noteRV: boolean;
	note: string;
	hash: string;
	listedExchanges?: TixSecondaryTypes[];
	preuploaded?: boolean;
};

export type TixSale = {
	id: string;
	eventId: TixEvent['id'];
	tixId: TixBought['id'][];
	secondary: TixSecondaryTypes;
	quantity: number;
	amount: number | null;
	reference: string | null;
	transferType: TixTransferTypes;
	status: TixCompletedStatusTypes;
	buyerEmail: string | null;
	buyerName: string | null;
	amountReceivedDate: string | null;
	hash: string;
	note: string | null;
} & ({ amountNative: number; amountCurrency: TixCurrencyTypes } | { amountNative: null; amountCurrency: null });
